import { trpc } from '@/shared/api';

/** HOME 함께한 기업(landing.listPartners) — 운영자가 등록한 로고. 배열 순서가 노출 순서다. 하나라도 있으면 사례 로고 대신 쓴다. */
export const useLandingPartnersQuery = () =>
  trpc.landing.listPartners.useQuery(undefined, { retry: false });
